export default function mParticleLogEvent() {
    const megaMenuClickedEventName = window && window.sessionStorage.getItem("megamenu_clicked");
    const megaMenuCTAClickedEventName = window && window.sessionStorage.getItem("megamenu_cta_clicked");
    const textCarouselItemClickedEventName = window && window.sessionStorage.getItem("navbar_carousel_clicked");
    const callToActionClicked = window && window.sessionStorage.getItem("call_to_action_clicked");

  if(callToActionClicked) {

    const attributes = JSON.parse(window.sessionStorage.getItem("call_to_action_clicked"));
    window.mParticle && window.mParticle.logEvent(
      "call_to_action_clicked",
      window.mParticle.EventType.Other,
      attributes
    );
    window.sessionStorage.removeItem("call_to_action_clicked");
  }

    if(megaMenuClickedEventName) {
        window.mParticle && window.mParticle.logEvent(
            "megamenu_clicked", 
            window.mParticle.EventType.Other, 
            {"name": megaMenuClickedEventName}
        );
        window.sessionStorage.removeItem("megamenu_clicked");
      }
    
    if(megaMenuCTAClickedEventName) {
        const attributes = JSON.parse(window.sessionStorage.getItem("megamenu_cta_clicked"));
        window.mParticle && window.mParticle.logEvent(
            "megamenu_cta_clicked", 
            window.mParticle.EventType.Other,
            attributes
        ); 
        window.sessionStorage.removeItem("megamenu_cta_clicked");
    }

    if(textCarouselItemClickedEventName) {
        const attributes = JSON.parse(window.sessionStorage.getItem("navbar_carousel_clicked"));
        window.mParticle && window.mParticle.logEvent(
            "navbar_carousel_clicked", 
            window.mParticle.EventType.Other,
            attributes
        ); 
        window.sessionStorage.removeItem("navbar_carousel_clicked");
    }
}